import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import "./Pursuits.css";
import skull from "../../assets/skull.svg";
import ag from "../../assets/ag.svg";

const Pursuits = () => {
  return (
    <div className="jus">
      <div className="cover">
        <div className="pursuits-section">
          <div className="pursuits">
            <div className="container">
              <h5 className="h5">Things I do</h5>
              <h2 className="lh2">
                <strong>Building bridges to </strong>Success
              </h2>
              <div className="services">
                <img
                  decoding="async"
                  src={ag}
                  alt="Awesome guys bubble"
                  className="tiny"
                  data-rellax-speed="1"
                />
                <img
                  decoding="async"
                  src={skull}
                  alt="Skull Icon"
                  className="skull"
                  data-rellax-speed="1"
                ></img>
                <div className="out-content">
                  <Swiper
                    modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                    spaceBetween={50}
                    slidesPerView={1}
                    navigation={false}
                    pagination={{ clickable: true }}
                    autoplay={{
                      delay: 10000,
                    }}
                  >
                    <SwiperSlide>
                      <div className="content">
                        <h2 id="pursuits" className="h2">
                          Web development
                        </h2>
                        <p><strong>“Crafting Web Experiences That Matter”</strong></p>
                        <p>
                          I combine design, development and innovation to craft web applications that don’t just function, but they inspire.</p>

                        <ul className="item-list">
                          <li><strong>Front-End Development</strong>: React, Angular, Bootstrap, Material-UI, SCSS</li>
                          <li><strong>Server & API Development</strong>: Django, Flask, FastAPI, Express</li>
                          <li><strong>Database</strong>: PostgreSQL</li>
                            <li>
    <strong>Design & Analytics:</strong> Figma, Power BI, Google Tag Manager, Google Analytics
  </li>
                        </ul>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide>
                      <div className="content">
                        <h2 id="pursuits" className="h2">
                          Competitive Coding
                        </h2>
                        <p><strong>“Optimizing problems and thereby ELAVATING solutions”</strong></p>
                        <p>
                          Solved 1100+ algorithmic problems across platforms, focusing on time-space optimization and clean problem decomposition.
                        </p>
                        <ul className="item-list">
                          <li><strong>Languages:</strong> Python, Java</li>
                          <li><strong>Competitive Platforms:</strong> LeetCode, GUVI, HackerRank</li>
                          <li><strong>Problem Solving Focus:</strong> Time and Space Optimization</li>
                        </ul>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide>
                      <div className="content">
                        <h2 id="pursuits" className="h2">
                          UX Design
                        </h2>
                        <p><strong>“Crafting intuitive DIGITAL journeys”</strong></p>
                        <p>
                          I specialize in designing user experiences that prioritize ease of use, functionality and aesthetics, ensuring that every interaction feels natural and engaging.
                        </p>
                        <ul className="item-list">
                          <li><strong>Focus: </strong>Wireframing, Prototyping, Visual Design</li>
                          <li><strong>Expertise: </strong>Mobile & Web Design, Accessibility</li>
                          <li><strong>Tools: </strong>Figma</li>
                        </ul>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide>
                      <div className="content">
                        <h2 id="pursuits" className="h2">
                          Financial Markets
                        </h2>
                        <p><strong>“Markets are systems... price is just one signal”</strong></p>
                        <p>
                          Actively involved in financial markets with a strong focus on disciplined investing and strategy-driven decision-making. I approach markets as systems—balancing risk, reward and long-term thinking.
                        </p>
                        <ul className="item-list">
                        <li><strong>Focus: </strong>TA, FA, MAEE, Alpha Generation</li>
                        <li><strong>Style: </strong>Sentimental, Strategic, Swing and Position</li>
                        <li><strong>Investments: </strong>Backing high-potential innovative companies</li>
                        <li><strong>Tools: </strong>TradingView (PineScript), Valuation Techniques</li>
                        </ul>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>

            <a
              href="#portfolio"
              className="r90 left hide-el bl has-rotate hide-m"
              data-cursor="false"
              data-cursor-type="link"
            >
              <span className="text"> Portfolio&nbsp;</span>
              <span className="left"> &rarr;</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pursuits;
